module.exports = __webpack_public_path__ + "6100903b739f1780c30e884bfad7ac01.MP3";